module.exports = __webpack_public_path__ + "media/images/footer/en_ef-c97cb41c63e0451b6f47a7f3fd2bb05f.svg";